export const user = "me";
export const login = "auth/login";
